module.exports = __webpack_public_path__ + "img/42.b579f72a.jpg";